import { Button } from "@/components/ui/button";
import { Users } from "lucide-react";
import { startNewFamilyOnboarding } from "@/utils/onboardingUtils";

interface NoFamilyMessageProps {
  title?: string;
  description?: string;
  buttonText?: string;
  variant?: "default" | "outline" | "secondary" | "destructive" | "ghost" | "link" | "persons" | "tasks" | "calendar" | "documents";
  className?: string;
}

export const NoFamilyMessage = ({ 
  title = "Créer une famille",
  description = "Vous devez d'abord créer une famille pour utiliser cette fonctionnalité",
  buttonText = "Créer ma famille",
  variant = "default",
  className = ""
}: NoFamilyMessageProps) => {
  const handleStartOnboarding = () => {
    // Clear any existing onboarding data and set new family mode
    startNewFamilyOnboarding();
    window.location.href = '/new-user-onboarding';
  };

  return (
    <div className={`min-h-screen bg-page-gradient ${className}`}>
      <div className="container mx-auto px-4 py-12 text-center flex flex-col items-center justify-center min-h-[60vh]">
        <div className="text-6xl mb-6">👨‍👩‍👧‍👦</div>
        <h1 className="text-2xl font-bold mb-4">{title}</h1>
        <p className="text-muted-foreground mb-8 max-w-md">
          {description}
        </p>
        <Button 
          onClick={handleStartOnboarding}
          variant={variant}
          size="lg"
          className="gap-2"
        >
          <Users className="h-5 w-5" />
          {buttonText}
        </Button>
      </div>
    </div>
  );
};